import React, { FC } from 'react';

import styled from 'styled-components/macro';

import media from 'helpers/media';

const Root = styled.div`
    margin: 0 auto;
    box-sizing: content-box;
    max-width: calc(100% - ${({ theme }) => theme.space.large});
    width: 100%;
    padding: 0 ${({ theme }) => theme.space.base};

    ${media.tablet`
        max-width: 668px;
    `}

    ${({ theme }) => media.laptop`
        padding: 0 ${theme.space.medium};
        max-width: calc(100% - ${theme.space.xlarge});
        max-width: 984px;
    `}

    ${({ theme }) => media.desktop`
        padding: 0 ${theme.space.medium};
        max-width: calc(100% - ${theme.space.xlarge});
        max-width: 1128px;
    `}
`;

const Container: FC<React.HTMLAttributes<HTMLDivElement>> = (args) => {
    return <Root {...args}>{args.children}</Root>;
};

export default Container;
